export * from './src/MatchMediaHOC';



// WEBPACK FOOTER //
// ./src/js/_libs/react-rx-match-media/index.js